import RunningExperimentsService from 'experiments/experiments-service';
import {FLAGS_SECTION, FLAGS_SECTION_VARIATION} from 'experiments/experiments-service.constants';

export const isInFlagsExp = () => {
    return RunningExperimentsService.isInExperimentBucket(FLAGS_SECTION, FLAGS_SECTION_VARIATION);
};
